export default {"src":"/_next/static/media/pidLogo.c5c43ddb.svg","height":30,"width":26};